<div class="disclaimer-dialog">

  <div class="disclaimer-header">
    <h4>DISCLAIMER</h4>
  </div>

  <div class="disclaimer-body">

    <p>
      Please note the contents of the pre-requisite docket are different for each ASD offerings
      (i.e. SAP S/4 HANA, SAP ECC, SAP BW, SAP APO).
    </p>

    <p>
      Kindly download the pre-requisite docket relevant for your scope of assessment.
      Also, kindly make sure to download the fresh pre-requisite docket when commencing
      the setup for the assessment since the contents of the docket are updated on a
      periodic basis with new features.
    </p>

    <p>
      Please feel free to reach out to ASD Team at
      <a href="mailto:asd.support@accenture.com">
        asd.support@accenture.com
      </a>
      in case any assistance is required.
    </p>

  </div>

  <div class="disclaimer-footer">

    <button type="button" class="proceed-btn" (click)="proceed()">

      <i class="fa fa-check"></i>
      PROCEED

    </button>

  </div>

</div>